import { formatAmplienceImageURL } from "@JohnLewisPartnership/jl-design-system/dist/utils/imageUrlModifier/imageUrlModifier";
import { GalleryImageObject } from "../../Galleries/utils/utils";
import styles from "./ZoomModalImage.module.scss";

interface ZoomModalImageProps {
  mediaItem: GalleryImageObject;
  index: number;
  total: number;
  onClick?: () => void;
  onKeyDown?: (event: React.KeyboardEvent) => void;
}

export const ZoomModalImage = ({
  mediaItem,
  index,
  total,
  onClick,
  onKeyDown,
}: ZoomModalImageProps) => {
  const srcSetValues = [
    "$rsp-pdp-port-320$ 320w",
    "$rsp-pdp-port-640$ 640w",
    "$rsp-pdp-port-1080$ 1080w",
    "$rsp-pdp-port-1440$ 1440w",
  ];
  const generateSrcSetUrl = (rspValue: string) =>
    formatAmplienceImageURL(`${mediaItem.imageUrl}?${rspValue}`);

  return (
    <button
      className={styles.imageButton}
      type="button"
      aria-label={`Product image ${index + 1} of ${total}, ${mediaItem.title}`}
      data-testid={`gallery:zoom:modal:image-${index}`}
      onClick={onClick}
      onKeyDown={onKeyDown}
    >
      <img
        src={formatAmplienceImageURL(mediaItem.imageUrl)}
        srcSet={`\n${srcSetValues.map((v) => generateSrcSetUrl(v)).join(",\n")}`}
        sizes="100vw"
        loading="eager"
        className={styles.image}
        alt={`Product image ${index + 1} of ${total}, ${mediaItem.title}`}
      />
    </button>
  );
};
